/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `CelebrationIconProps` interface defines the properties for the CelebrationIcon component.
 */
interface CelebrationIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "celebration" — outlined, weight 300.
 * Party popper icon for the Feste und Feiern (Festivals) category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const CelebrationIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'CelebrationIcon',
    width
}: CelebrationIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m111.93-113.08 165.22-461.53 298.54 295.69-463.76 165.84Zm76.38-76.38L493.46-298 296.23-496.23 188.31-189.46Zm352.92-252.85-27.85-27.84 231.16-231.16q30.07-29.69 75.61-30.19t75.62 29.58l14.3 14.31L883-659.77l-15.54-15.92q-19.77-19.77-46.31-20.08-26.54-.31-46.92 20.08l-233 233.38ZM395.69-585l-27.84-27.46 28.46-28.46q24.54-24.54 23.42-56.73-1.11-32.19-23.42-54.5L369.46-779l27.85-27.46 25.23 25.23q34.61 34.23 34.11 85t-34.73 85L395.69-585Zm73.69 70.85-27.46-27.46L587-687.08q19.77-19.38 19.46-49.26-.31-29.89-20.08-49.66l-57.15-57.15 27.46-27.46 58.77 58.38q29.46 30.46 30.27 75.89.81 45.42-29.65 75.5l-146.7 146.69Zm144.93 145.53-27.85-27.46 35.46-35.46q34.62-34.61 83.23-35.42 48.62-.81 83.23 33.81l38.31 38.3L799.23-367l-39.31-39.31q-24.54-24.54-53.96-24.54t-54.35 24.54l-37.3 37.69Zm-426 179.16Z" />
    </svg>
);

CelebrationIcon.displayName = 'CelebrationIcon';